import React from "react";
import styled from "styled-components";
import arrow from "../../Assets/arrow-light.svg"
import { ButtonBack, ButtonNext, CarouselProvider, Dot, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';

const Style = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    min-height: 60vh;
    position: relative;
    .slider {
        flex-grow: 1;
        margin: 2rem;
        border-radius: 1.5rem;
        backdrop-filter: blur(20px);
        overflow: hidden;
        .slidesRow {
            position: absolute;
            display: flex;
            inset: 0 auto 0 0;
            box-sizing: border-box;
            transition: all 0.3s ease-in-out;
        }
        .slide {
            overflow: hidden;
            text-align: left;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: end;
            isolation: isolate;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: end;
            padding: 0;
            color: #fff;
            position: relative; 
            .carousel__inner-slide {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                justify-content: end;
                padding: 0;
                color: #fff;
            }
            .image {
                z-index: -2;
                position: absolute;
                inset: 0 0 0 0;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                }
            }
            .color {
                z-index: -1;
                position: absolute;
                inset: -20px -20px -20px -20px;
                /* transform: scale(1.5); */
                overflow: hidden;
                /* backdrop-filter: blur(10px); */
                transition: all 0.3s ease-in-out;
            }
            .title {
                z-index: 5;
                font-size: 2rem;
                font-weight: 800;
                width: 50%;
                margin-left: 10vh;
                margin-bottom: 0.5rem;
                letter-spacing: 2px;
            }
            .text {
                z-index: 5;
                width: 50%;
                margin-left: 10vh;
                margin-bottom: 10vh;
                font-size: 1.3rem;
            }
            
        }
    }
    .bullets {
        display: flex;
        justify-content: center;
        position: absolute;
        inset: auto 0 0.5rem 0;
        .bullet {
            width: 0.5rem;
            height: 0.5rem;
            background-color: #ccc;
            margin: 0.25rem;
            border-radius: 100%;
            outline: none;
            border: none;
            &.carousel__dot--selected {
                background-color: #aaa;
            }
        }
    }
    .arrow {
        cursor: pointer;
        position: absolute;
        inset: 0 0 0 0;
        width: 2rem;
        height: 2rem;
        background-color: #fff;
        border-radius: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        text-align: center;
        outline: none;
        border: none;
        &.right {
            inset: calc(50% - 1rem) 1rem auto auto;
        }
        &.left {
            inset: calc(50% - 1rem) auto auto 1rem;
        }
        img {
            margin: auto;
        }
    }
    @media (max-width: 850px){
        min-height: 80vh;
        .carousel {
            .slide {
                .title {
                    font-size: 1.7rem;
                    font-weight: 800;
                    width: auto;
                    margin: 0 10vw 0.5rem 10vw;
                    letter-spacing: 2px;
                }
                .text {
                    z-index: 5;
                    width: 50%;
                    width: auto;
                    margin: 0 10vw 10vw 10vw;
                    font-size: 1.1rem;
                }
            }
        }
    }
`;

export default function MainSlider({data}) {
    const makeSlides = () => {
        let slidesHtml = [];
        data.data.forEach((value, index) => {
            slidesHtml.push(
                <Slide className="slide" key={index} index={index}>
                    <div className="image">
                        <img src={value.image} alt={value.title}/>
                    </div>
                    <div className="color"
                        style={{
                            background: `linear-gradient(${(window.innerWidth < 1000) ? '0deg' : '90deg'}, ${value.color} 0%,${value.color} 20%, #00000000 70%, ${((data.data[index + 1]) ? data.data[index + 1].color : value.color)} 100%)`
                        }}
                    >
                    </div>
                    <div className="title">
                        {value.title}
                    </div>
                    <div className="text">
                        {value.text}
                    </div>
                </Slide>
            )
        });
        
        return slidesHtml
    }
    const makeBullets = () => {
        return data.data.map((val, index) => {
            return <Dot 
                        className={"bullet" } 
                        slide={index} 
                        key={index}
                    >
                    </Dot>
        })
    }
    let height = ((0.60 * window.innerHeight)/ (window.innerWidth - 32)) * 100;
    if(window.innerWidth < 1000){
        height = ((0.80 * window.innerHeight)/ (window.innerWidth - 32)) * 100;
    }

    return (
      <Style>
        <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={height}
                totalSlides={data.data.length}
                playDirection="forward"
                currentSlide={1}
                visibleSlides={1}
                infinite={true}
                interval={2000}
                isPlaying={true}
                lockOnWindowScroll={true}
            >
                <Slider className="slider">
                    {makeSlides()}
                </Slider>
                <div className="bullets">
                    {makeBullets()}
                </div>
                <ButtonNext className="arrow right">
                    <img src={arrow} alt="arrow" style={{transform: "rotate(-90deg)"}}/>
                </ButtonNext>
                <ButtonBack className="arrow left">
                    <img src={arrow} alt="arrow" style={{transform: "rotate(90deg)"}}/>
                </ButtonBack>
        </CarouselProvider>
            

        
      </Style>
  );
}
